var Tooltip = class extends HTMLElement {
  constructor() {
    super();
    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._onMouseLeave = this._onMouseLeave.bind(this);
    this._onFocusIn = this._onFocusIn.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onViewportChange = this._onViewportChange.bind(this);
    this._closeTimer = null;
  }
  connectedCallback() {
    this.addEventListener("mouseenter", this._onMouseEnter);
    this.addEventListener("mouseleave", this._onMouseLeave);
    this.addEventListener("focusin", this._onFocusIn);
    this.addEventListener("click", this._onClick);
    window.addEventListener("resize", this._onViewportChange);
    this._syncPosition();
  }
  disconnectedCallback() {
    this.removeEventListener("mouseenter", this._onMouseEnter);
    this.removeEventListener("mouseleave", this._onMouseLeave);
    this.removeEventListener("focusin", this._onFocusIn);
    this.removeEventListener("click", this._onClick);
    window.removeEventListener("resize", this._onViewportChange);
    this._clearCloseTimer();
    this.classList.remove("tooltip--pointer-open");
  }
  _usePointerBridge() {
    return (
      window.matchMedia("(min-width: 700px)").matches &&
      window.matchMedia("(hover: hover) and (pointer: fine)").matches
    );
  }
  _clearCloseTimer() {
    if (this._closeTimer != null) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
  }
  _onMouseEnter() {
    if (this._usePointerBridge()) {
      this._clearCloseTimer();
      this.classList.add("tooltip--pointer-open");
    }
    this._syncPosition();
  }
  _onMouseLeave() {
    if (!this._usePointerBridge()) {
      return;
    }
    this._closeTimer = window.setTimeout(() => {
      this.classList.remove("tooltip--pointer-open");
      this._closeTimer = null;
    }, 200);
  }
  _onFocusIn() {
    this._syncPosition();
  }
  _onClick() {
    this._syncPosition();
  }
  _onViewportChange() {
    this._syncPosition();
  }
  _syncPosition() {
    this._positionForMobileViewport();
    this._clampTooltipToViewport();
  }
  _getGutterPx() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--gutter").trim();
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : 20;
  }
  _positionForMobileViewport() {
    const content = this.querySelector(".tooltip__content");
    if (!content) {
      return;
    }
    if (!window.matchMedia("screen and (max-width: 699px)").matches) {
      content.style.left = "";
      content.style.transform = "";
      return;
    }
    content.style.removeProperty("--tooltip-clamp-x");
    const tooltipRect = this.getBoundingClientRect();
    content.style.left = `calc(var(--gutter) - ${tooltipRect.left}px)`;
    if (this.getAttribute("open-from") === "bottom") {
      content.style.transform = "translate(0, var(--tooltip-offset))";
    } else {
      content.style.transform = "translate(0, calc(-100% - var(--tooltip-offset)))";
    }
  }
  _clampTooltipToViewport() {
    const content = this.querySelector(".tooltip__content");
    if (!content) {
      return;
    }
    if (!window.matchMedia("screen and (min-width: 700px)").matches) {
      content.style.removeProperty("--tooltip-clamp-x");
      return;
    }
    const gutter = this._getGutterPx();
    const vw = window.innerWidth;
    const prevRaw = getComputedStyle(content).getPropertyValue("--tooltip-clamp-x").trim();
    const prev = parseFloat(prevRaw);
    let dx = Number.isFinite(prev) ? prev : 0;
    for (let i = 0; i < 4; i++) {
      content.style.setProperty("--tooltip-clamp-x", `${dx}px`);
      void content.offsetWidth;
      const rect = content.getBoundingClientRect();
      let adjust = 0;
      if (rect.left < gutter) {
        adjust += gutter - rect.left;
      }
      if (rect.right > vw - gutter) {
        adjust -= rect.right - (vw - gutter);
      }
      if (Math.abs(adjust) < 0.5) {
        break;
      }
      dx += adjust;
    }
    content.style.setProperty("--tooltip-clamp-x", `${dx}px`);
  }
};
if (!window.customElements.get("x-tooltip")) {
  window.customElements.define("x-tooltip", Tooltip);
}
